/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_NameInputs */



/**
* | output |
* | --- |
* | "Project Name" |
*
* @param {Options_General_Project_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_name = /** @type {((inputs?: Options_General_Project_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do projeto")
	return /** @type {LocalizedString} */ ("Project Name")
});